
import React, { useState } from "react";

const EditCatModal = ({ selectedCategory, handleInputChange, setIsModalOpen, handleSave }) => {
  const [error, setError] = useState("");

  const validateInput = () => {
    if (!selectedCategory?.name.trim()) {
      setError("Category name cannot be empty or only spaces.");
      return false;
    }
    setError("");
    return true;
  };

  const onSave = (e) => {
    if (validateInput()) {
      handleSave(e); // Proceed only if validation passes
    }
  };

  return (
    <div>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 bg-black/50 backdrop-blur-sm">
        <div className="w-full p-8 bg-white rounded-lg shadow-lg sm:w-96">
          <h3 className="mb-6 text-2xl font-semibold text-center text-gray-800">Edit Category</h3> 
          <input
            type="text"
            value={selectedCategory?.name}
            onChange={handleInputChange} 
            name="name"
            className="w-full px-4 py-2 mb-4 transition duration-200 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter category name"
          />
          {error && <p className="mb-4 text-sm text-red-500">{error}</p>} 
          <div className="flex justify-between gap-4">
            <button
              onClick={() => setIsModalOpen(false)}
              className="w-full py-2 text-gray-700 transition-all border border-gray-300 rounded-md hover:bg-gray-100 focus:outline-none"
            >
              Cancel
            </button>
            <button
              onClick={(e) => onSave(e)}
              className="w-full py-2 text-white transition-all bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCatModal;

// import React, { useState } from "react";

// const EditCatModal = ({ selectedCategory, handleInputChange, setIsModalOpen, handleSave }) => {
//   const [error, setError] = useState("");

//   const validateInput = () => {
//     if (!selectedCategory?.name.trim()) {
//       setError("Category name cannot be empty or only spaces.");
//       return false;
//     }
//     setError("");
//     return true;
//   };

//   const onSave = (e) => {
//     if (validateInput()) {
//       handleSave(e); // Proceed only if validation passes
//     }
//   };

//   return (
//     <div>
//       <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
//         <div className="p-6 bg-white rounded-lg shadow-lg w-80">
//           <h3 className="mb-4 text-lg font-semibold">Edit Category</h3>
//           <input
//             type="text"
//             value={selectedCategory?.name}
//             onChange={handleInputChange} // Always update the state without validation
//             name="name"
//             className="w-full px-3 py-2 mb-2 border border-gray-300 rounded-lg"
//           />
//           {error && <p className="mb-2 text-sm text-red-500">{error}</p>}
//           <div className="flex justify-end gap-2">
//             <button
//               onClick={() => setIsModalOpen(false)}
//               className="px-4 py-2 text-white transition bg-gray-400 rounded hover:bg-gray-500"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={(e)=>onSave(e)}
//               className="px-4 py-2 text-white transition bg-blue-500 rounded hover:bg-blue-600"
//             >
//               Save
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditCatModal;
